import { render } from "./DefaultOpenExample.vue?vue&type=template&id=b1cc7e3c&bindings={\"changeTab\":\"options\"}"
import script from "./DefaultOpenExample.vue?vue&type=script&lang=js"
export * from "./DefaultOpenExample.vue?vue&type=script&lang=js"
script.render = render

export default script